import { Project } from "@/commons/interface/project/project";
import { StdResponse, bimAxios } from "@/config/axios";
import qs from "qs";

export function getProjects(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects`, {
        params: {
            ...params,
        }
    })
}
export function getProjectDetail(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}`, {
        params: {
            ...params,
        }
    })
}

export function createProject(data: Project, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects`, data, {
        params: {
            ...params,
        }
    })
}

export function updateProject(projectUuid: string, data: Project, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/projects/${projectUuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteProject(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}`, {
        params: {
            ...params,
        }
    })
}

export function findProjectListByUser(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/user/projects`, {
        params: {
            ...params,
        }
    })
}

export function addUserProjectPermission(userUuids: string[], projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/users/projects/${projectUuid}`, {}, {
        params: {
            userUuids: userUuids,
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function findRsProjectUserListByProject(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/users`, {
        params: {
            ...params,
        }
    })
}